import { render, staticRenderFns } from "./TalentScoreCard.vue?vue&type=template&id=7ecf1396&scoped=true&"
import script from "./TalentScoreCard.vue?vue&type=script&lang=js&"
export * from "./TalentScoreCard.vue?vue&type=script&lang=js&"
import style0 from "./TalentScoreCard.vue?vue&type=style&index=0&id=7ecf1396&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecf1396",
  null
  
)

export default component.exports